import React, { useEffect, useRef, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
const HERO_POSTER = 'https://cdn.magicpatterns.com/patterns/generated-images/cda00bca-10eb-4c61-928f-55529cc255f9.jpg';

// PLACEHOLDER — sustituir por el film silencioso final (Porsche en carretera de montaña).
// El póster se mantiene visible si el archivo no está disponible.
const HERO_VIDEO = 'https://cdn.coverr.co/videos/coverr-driving-through-the-mountains-1080p.mp4';
export function Hero() {
  const {
    t
  } = useLanguage();
  const [offset, setOffset] = useState(0);
  const [videoFailed, setVideoFailed] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  // Parallax: la imagen se desplaza a ~38% de la velocidad de scroll
  useEffect(() => {
    let frame = 0;
    const onScroll = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => setOffset(window.scrollY * 0.38));
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  // Respeta reduced-motion: congela el film en su primer fotograma
  useEffect(() => {
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (media.matches) videoRef.current?.pause();
  }, []);
  return <section aria-labelledby="hero-title" className="relative flex h-[86vh] min-h-[580px] w-full items-end overflow-hidden bg-canvas lg:h-[calc(100vh-7rem)]" data-id="element-166" data-mp="3e7l7m1sxskj6">
      <div className="absolute inset-0 h-[145%] w-full" style={{
      transform: `translate3d(0, ${offset}px, 0)`
    }} aria-hidden="true" data-id="element-167" data-mp="359j85qoupzy0">
        <img src={HERO_POSTER} alt="" className="absolute inset-0 h-full w-full object-cover opacity-70" data-id="element-168" data-mp="2viojygs1oq9x" />
        {!videoFailed && <video ref={videoRef} className="absolute inset-0 h-full w-full object-cover opacity-70" src={HERO_VIDEO} poster={HERO_POSTER} autoPlay muted loop playsInline preload="metadata" onError={() => setVideoFailed(true)} data-id="element-169" data-mp="2hlj9m4lat58v" />}
      </div>

      <div className="absolute inset-0 bg-canvas/50" aria-hidden="true" data-id="element-170" data-mp="ichz1524ii4l" />

      <div className="relative mx-auto w-full max-w-[1520px] px-5 pb-14 sm:px-6 sm:pb-20 lg:px-14 lg:pb-28" data-id="element-171" data-mp="de6rj0zawjpj">
        <div className="relative max-w-3xl border-l border-white/15 pl-5 lg:pl-10" data-id="element-172" data-mp="1b0drtyoknpw3">
          <span className="absolute left-0 top-0 h-px w-4 bg-white/40 lg:w-6" aria-hidden="true" data-id="element-173" data-mp="162ufj4bfpn6s" />
          <span className="absolute bottom-0 left-0 h-px w-4 bg-white/40 lg:w-6" aria-hidden="true" data-id="element-174" data-mp="111omt6hrxzx9" />
          <div className="flex items-center gap-4" data-id="element-175" data-mp="x37cyf6yybc5">
            <span className="h-px w-8 bg-white/50 lg:w-12" aria-hidden="true" data-id="element-176" data-mp="3lt74sotvtnt7" />
            <p className="text-[11px] uppercase tracking-[0.34em] text-mute" data-id="element-177" data-mp="3hrlp6vpyqvfb">{t.hero.eyebrow}</p>
          </div>
          <h1 id="hero-title" className="mt-5 text-[42px] font-light leading-[1.02] tracking-[-0.035em] text-white sm:text-6xl lg:text-[84px]" data-id="element-178" data-mp="1xa41h7xz88gg">
            {t.hero.title}
          </h1>
          <p className="mt-5 max-w-xl text-[15px] font-light leading-relaxed text-mute sm:mt-7 sm:text-base lg:text-lg" data-id="element-179" data-mp="2697m4gcskvx2">
            {t.hero.subtitle}
          </p>
          <div className="mt-9 flex flex-col gap-3 sm:mt-11 sm:flex-row sm:flex-wrap sm:items-center" data-id="element-180" data-mp="2g02hqbbxh7v6">
            <a href="#inventario" className="btn-glint btn-glint-sheen btn-halo-red inline-flex items-center justify-center bg-guards px-8 py-4 text-[13px] font-medium tracking-wide text-white hover:bg-guards-bright sm:px-10" data-id="element-181" data-mp="2kydtirls9sg1">
              <span data-id="element-182" data-mp="2tx7lu5s2zwns">{t.hero.ctaPrimary}</span>
            </a>
            <a href="#contacto" className="btn-glint btn-glint-sheen btn-halo-blue inline-flex items-center justify-center border border-gentian-bright/70 bg-transparent px-8 py-4 text-[13px] font-medium tracking-wide text-white transition-colors duration-500 ease-[var(--ease-lux)] hover:border-gentian-bright hover:bg-gentian/25 sm:px-10" data-id="element-183" data-mp="unrbv0pwrruz">
              <span data-id="element-184" data-mp="e8imhpn92na6">{t.hero.ctaSecondary}</span>
            </a>
          </div>

          <div className="mt-12 hidden items-center gap-6 border-t border-white/12 pt-5 text-[10px] uppercase tracking-[0.28em] text-mute lg:flex" data-id="element-185" data-mp="99xlvp4361l7">
            <span data-id="element-186" data-mp="3hqk0yhn82w9b">15055 Biscayne Blvd</span>
            <span className="h-2 w-px bg-white/25" aria-hidden="true" data-id="element-187" data-mp="3crftbvfy56l3" />
            <span data-id="element-188" data-mp="3cp34cybrtvyj">North Miami, FL</span>
            <span className="h-2 w-px bg-white/25" aria-hidden="true" data-id="element-189" data-mp="3rgbxviiso1gy" />
            <span data-id="element-190" data-mp="3mpdf8cac2raj">{t.hero.metaOfficial}</span>
          </div>
        </div>
      </div>

      <a href="#categorias" aria-label={t.hero.scrollAria} className="absolute bottom-8 left-1/2 hidden -translate-x-1/2 flex-col items-center gap-3 lg:flex" data-id="element-191" data-mp="3mnit4unbst4v">
        <span className="text-[10px] uppercase tracking-[0.3em] text-mute" data-id="element-192" data-mp="2tylo3t84ksu2">{t.hero.scroll}</span>
        <span className="scroll-cue relative h-12 w-px overflow-hidden bg-line" aria-hidden="true" data-id="element-193" data-mp="19gkk0t64zpja" />
        <span className="cue-dot h-[3px] w-[3px] rounded-full bg-white" aria-hidden="true" data-id="element-194" data-mp="1ebgo4rone3cr" />
      </a>
    </section>;
}